document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('.menu-button');
  const nav = document.querySelector('.main-nav');
  if (button && nav) button.addEventListener('click', () => {
    const open = nav.classList.toggle('open');
    button.setAttribute('aria-expanded', String(open));
    button.textContent = open ? '×' : '☰';
  });

  document.querySelectorAll('[data-infuzze-product-section]').forEach(section => {
    const select = section.querySelector('.product-variant-select');
    if (select) updateProductVariantPrice(select);
    const activePackFormat = section.querySelector('[data-pack-format].is-active');
    if (!select && activePackFormat) {
      updateProductFormatBadge(section, activePackFormat.dataset.packFormat || '100g');
    }
  });
});

function getInfuzzeFormat(value) {
  const text = String(value || '').toLowerCase();
  return /infusette|dosette|sachet/.test(text) ? 'infusettes' : '100g';
}

function updateProductFormatBadge(productSection, format) {
  if (!productSection) return;
  const badge = productSection.querySelector('[data-product-format-badge]');
  if (!badge) return;
  const normalized = format === 'infusettes' ? 'infusettes' : '100g';
  const mainTarget = badge.querySelector('[data-badge-main]');
  const subTarget = badge.querySelector('[data-badge-sub]');
  const mainText = normalized === 'infusettes' ? (badge.dataset.mainInfusettes || '') : (badge.dataset.mainBulk || '');
  const subText = normalized === 'infusettes' ? (badge.dataset.subInfusettes || '') : (badge.dataset.subBulk || '');
  if (mainTarget) mainTarget.textContent = mainText;
  if (subTarget) subTarget.textContent = subText;
  badge.dataset.currentFormat = normalized;
}

function updateProductVariantPrice(select) {
  const option = select.options[select.selectedIndex];
  const form = select.closest('form');
  if (!option || !form) return;

  const price = form.querySelector('.product-button-price');
  const button = form.querySelector('.add-button');
  const label = form.querySelector('.product-cart-label');
  const productSection = select.closest('[data-infuzze-product-section]');
  const singleOptionPrice = productSection ? productSection.querySelector('[data-single-option-price]') : null;
  const available = option.dataset.available === 'true';
  const mainImage = productSection ? productSection.querySelector('.product-main-image img') : null;
  if (mainImage && option.dataset.imageSrc) {
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.src = option.dataset.imageSrc;
    mainImage.alt = option.dataset.imageAlt || '';
    if (option.dataset.imageWidth && option.dataset.imageHeight) {
      mainImage.width = Number(option.dataset.imageWidth);
      mainImage.height = Number(option.dataset.imageHeight);
    } else {
      mainImage.removeAttribute('width');
      mainImage.removeAttribute('height');
    }
  }

  if (price) price.textContent = `${option.dataset.price} ↗`;
  if (singleOptionPrice) singleOptionPrice.textContent = option.dataset.price;
  if (button) button.disabled = !available;
  if (label) label.textContent = available ? (label.dataset.availableLabel || label.textContent) : 'Épuisé';
  updateProductFormatBadge(productSection, getInfuzzeFormat(option.textContent || option.value));
}

document.addEventListener('change', (event) => {
  if (event.target.matches('.product-variant-select')) updateProductVariantPrice(event.target);
});

document.addEventListener('click', (event) => {
  const formatButton = event.target.closest('[data-pack-format]');
  if (!formatButton) return;
  const productSection = formatButton.closest('[data-infuzze-product-section]');
  updateProductFormatBadge(productSection, formatButton.dataset.packFormat || '100g');
});
